/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useState } from 'react';
import 'firebase/storage';
import FileDisplay from './FileDisplay';
import HorizontalCenter from '@components/common/alignment/HorizontalCenter';
import LargeBlueButton from '@components/common/button/LargeBlueButton';
import { useAsync } from '@util/customhooks/useAsync';
import { loadGooglePicker } from './drive/loadGooglePicker';
import { LoadingIndicator } from '@components/common/Loading';
import { FileInfo } from '@data/course/courseData';

// These are all arrays even though we only take one file at the moment
// because I was too lazy to fix it and I guess it's nice to have the option for the future
interface CurriculumFileUploaderProps {
  files: FileInfo[];
  addFiles: (files: FileInfo[]) => void;
  removeFile: (id: FileInfo) => void;
}

const loadPicker = () =>
  loadGooglePicker(
    process.env.REACT_APP_PICKER_CLIENT_ID!,
    process.env.REACT_APP_PICKER_DEV_KEY!,
    process.env.REACT_APP_PICKER_APP_ID!
  );

const CurriculumFileUploader: React.FC<CurriculumFileUploaderProps> = ({
  files,
  addFiles,
  removeFile,
}) => {
  const [getSelectedFiles, pickerLoading] = useAsync(loadPicker);

  const [error, setError] = useState('');

  const handleClick = async () => {
    if (!getSelectedFiles) {
      setError('Failed to load Google Drive File Picker');
      return;
    }
    try {
      const pickerFiles = await getSelectedFiles();
      const files = pickerFiles.map((x) => ({
        url: x.webViewLink ?? '',
        filename: x.name ?? 'Curriculum Submission',
      }));
      addFiles(files);
      setError('');
    } catch {
      setError('Failed to get selected files.');
    }
  };

  return (
    <div className='flex flex-col'>
      <HorizontalCenter>
        {pickerLoading ? (
          <LoadingIndicator className='text-xl'></LoadingIndicator>
        ) : (
          <LargeBlueButton
            text='ADD FILES'
            className='my-4'
            onClick={handleClick}
            clickable={files.length < 1}
          ></LargeBlueButton>
        )}
      </HorizontalCenter>
      <div>
        {files.map((f, index) => (
          <HorizontalCenter key={index}>
            <FileDisplay file={f} removable onRemove={() => removeFile(f)}></FileDisplay>
          </HorizontalCenter>
        ))}
      </div>
      <p className='text-red-600 text-center'>{error}</p>
      <a
        href='https://docs.google.com/document/d/1K8vFBJLKX6a-MCkC7i55HSCnX6TWVa3KftV6bRH_P9Q/copy?usp=sharing'
        className='mt-auto text-center link-blue'
      >
        Access the curriculum template
      </a>
    </div>
  );
};

export default CurriculumFileUploader;
